import dayjs from 'dayjs';
import {
  useReduceWithModel,
  IModel,
} from '@/hooks/useReduceWithModel/useReduceWithModel';
import {
  IFetchCouponList,
  Achieved,
  Received,
  CouponStatus,
  IFetchAchieveCoupon,
} from '@/services/atmosphereTypes';

interface IState {
  couponList: IFetchCouponList['result'];
  coupnCardList: IFetchCouponList['result'];
  achieveCoupon: IFetchAchieveCoupon['result'];
}

const initialState: IState = {
  couponList: [],
  coupnCardList: [],
  achieveCoupon: {
    release_batch: '',
    is_achieved: 0,
    is_received: 0,
  },
};

/**
 * 可以直接返回state，也可以修改draft里面的数据，返回空
 * @param draft
 * @param action
 */

enum actionEnum {
  initalialCoupon = 'initalialCoupon',
  reset = 'reset',
  increment = 'increment',
  achiveCoupon = 'achiveCoupon',
}
const couponItem = (list: IFetchCouponList['result']) => {
  let status: CouponStatus = CouponStatus.canGet;
  const newlist = list?.map((v: IFetchCouponList['result'][0]) => {
    if (v.is_achieved === Achieved.yes && v.is_received === Received.yes) {
      // 未领取 && 可以领取
      status = CouponStatus.canGet;
    } else if (
      v.is_achieved === Achieved.yes &&
      v.is_received === Received.no
    ) {
      // 已领取
      status = CouponStatus.get;
    } else if (v.is_achieved === Achieved.no) {
      //  抢光，不可获取
      status = CouponStatus.over;
    }
    return {
      release_batch: v.release_batch,
      discount: v.discount,
      discountText: v.condition,
      title: v.title,
      subText: v.object,
      tip: v.remark,
      status,
      type: v.type,
      is_achieved: v.is_achieved,
      is_received: v.is_received,
      startTime: dayjs(v.start_time).format('YYYY.MM.DD'),
      endTime: dayjs(v.end_time).format('YYYY.MM.DD'),
    };
  });
  return newlist;
};
const model: IModel<IState> = {
  immer: true,
  state: initialState,
  reducers: {
    [actionEnum.initalialCoupon](
      state: IState,
      action: { type: actionEnum; [extraProps: string]: any },
    ) {
      return {
        ...state,
        couponList: action.payload,
        coupnCardList: couponItem(action.payload),
      };
    },
    [actionEnum.achiveCoupon](
      state: IState,
      action: { type: actionEnum; [extraProps: string]: any },
    ) {
      let list = JSON.parse(JSON.stringify(state.couponList));
      list = list.map((v: { release_batch: string }) => {
        if (v.release_batch === action.payload.release_batch) {
          const _v = {
            ...v,
            is_achieved: action.payload.is_achieved,
            is_received: action.payload.is_received,
          };
          return _v;
        }
        return v;
      });
      const carList = couponItem(list);
      return {
        ...state,
        couponList: list,
        coupnCardList: carList,
      };
    },
    [actionEnum.reset](
      state: IState,
      action: { type: actionEnum; [extraProps: string]: any },
    ) {
      return {
        ...state,
        couponList: [],
        coupnCardList: [],
      };
    },
  },
};
const useCouponModel = () => {
  const [state, dispatch] = useReduceWithModel(model);
  // 缓存商品列表
  const initalialCoupon = (couponList: IFetchCouponList['result']) =>
    dispatch({ type: actionEnum.initalialCoupon, payload: couponList });
  const reset = () => dispatch({ type: actionEnum.reset });
  // 获取优惠券
  const achiveCoupon = (achiveCouponStatus: IFetchAchieveCoupon['result']) =>
    dispatch({ type: actionEnum.achiveCoupon, payload: achiveCouponStatus });
  return {
    state,
    initalialCoupon,
    reset,
    achiveCoupon,
  };
};

export default useCouponModel;
